/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import s from './MLTextField.module.css';
import MLIcon from '../MLIcon';

function MLTextField(props) {
  const {
    name,
    containerClassName,
    className,
    type,
    placeholder,
    disabled,
    labelledBy,
    invalidError,
    hasError,
    errorMessages,
    focus,
    value,
    onChange,
    onFocus,
    readOnly,
    inputRef,
    iconType,
    iconClassName,
    testId,
    iconOnClick,
    iconButtonAriaLabel,
    min,
    max,
    onBlur,
    ariaLabel,
    maxLength,
    onKeyPress,
  } = props;

  const errorClass = hasError ? s.MLTextFieldInputError : '';

  const invalidErrorClass = invalidError ? s.invalidError : '';
  const onBlurInternal = (e) => {
    if (onBlur) onBlur(e);
  };
  const onChangeInternal = (e) => {
    if (onChange) onChange(e, e.target.value);
  };

  return (
    <div className={`${s.MLTextFieldContainer} ${containerClassName}`}>
      <input
        className={`${s.MLTextFieldInput} ${className} ${errorClass} ${invalidErrorClass}`}
        type={type}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        aria-labelledby={labelledBy}
        readOnly={readOnly}
        value={value}
        onChange={onChangeInternal}
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={focus}
        ref={inputRef}
        data-test-id={testId}
        min={min}
        max={max}
        maxLength={maxLength}
        onFocus={onFocus}
        onBlur={onBlurInternal}
        aria-label={ariaLabel || ''}
        onKeyPress={onKeyPress}
      />
      {hasError &&
        _map(errorMessages, (errorMessage, i) => (
          <div className={s.MLTextFieldErrorText} key={i}>
            <span>{errorMessage}</span>
          </div>
        ))}
      {iconType && iconOnClick && (
        <button
          type="button"
          className={s.iconButton}
          onClick={iconOnClick}
          disabled={disabled || readOnly}
          aria-label={iconButtonAriaLabel}
        >
          <MLIcon
            type={iconType}
            className={`${s.iconSymbol} ${iconClassName || ''}`.trim()}
            ariaHidden
          />
        </button>
      )}
      {iconType && !iconOnClick && (
        <MLIcon
          type={iconType}
          className={`${s.iconDefaults} ${iconClassName || ''}`.trim()}
        />
      )}
    </div>
  );
}

MLTextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  labelledBy: PropTypes.string,
  readOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  focus: PropTypes.bool,
  errorMessages: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  autoFocus: PropTypes.bool,
  inputRef: PropTypes.object,
  iconType: PropTypes.string,
  iconOnClick: PropTypes.func,
  iconButtonAriaLabel: PropTypes.string,
  iconClassName: PropTypes.string,
  invalidError: PropTypes.object,
  testId: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  onKeyPress: PropTypes.func,
};

export default MLTextField;
